import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { supabase } from "../lib/supabaseClient";

export default function ProtectedRoute() {
  const [checking, setChecking] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    async function check() {
      const { data: { session } } = await supabase.auth.getSession();

      if (!session) {
        setAllowed(false);
        setChecking(false);
        return;
      }

      // Check profile is active
      const { data: profile } = await supabase
        .from("profiles")
        .select("active")
        .eq("user_id", session.user.id)
        .single();

      // If active column doesn't exist yet or is true, allow through
      setAllowed(profile?.active !== false);
      setChecking(false);
    }

    check();
  }, []);

  if (checking) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-800" />
      </div>
    );
  }

  return allowed ? <Outlet /> : <Navigate to="/login" replace />;
}
